<div
  *ngIf="colVm.columnType === Types.SectionColumnProductInfoType.VariantType"
  class="product-column-general product-variant-type"
  [style.visibility]="section?.collapseContent || rowVm.collapseContent ? 'collapse' : ''"
  [style.text-decoration]="productStylingVm | forcedColumnTextDecoration: colVm : locConfig | async"
  [style.margin-right]="menu | productMenuBasicMethod: 'getSectionBorderMarginSize'">
  <app-handle-badge-mode
    [colVm]="colVm"
    [rowVm]="rowVm"
    [nonListColumnBadgeAsset]="this | method: 'getNonListColumnItem'">
    {{ this | method: 'getNonListColumnItem' }}
  </app-handle-badge-mode>
</div>
